import SpeedNetworkingService from "@/services/speedNetworking/speedNetworking.service";
const _speedNetworkingService = new SpeedNetworkingService();

const setWaitingMeetingAction = ({ commit }, payload) => {
  commit("setWaitingMeeting", payload);
};

const setUserInMeetingAction = ({ commit }, payload) => {
  commit("setUserInMeeting", payload);
};

const setEnterInNetworkingAction = ({ commit }, payload) => {
  commit("setEnterInNetworking", payload);
};

const setShowEnterModalAction = ({ commit }, payload) => {
  commit("setShowEnterModal", payload);
};

const setWaitingTimeAction = ({ commit }, payload) => {
  commit("setWaitingTime", payload);
};

const setMeetingTimeAction = ({ commit }, payload) => {
  commit("setMeetingTime", payload);
};

const joinSpeedNetworkingAction = ({ commit }, { roomId, callback }) => {
  _speedNetworkingService
    .joinSpeedNetworking(roomId)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => console.log(error));
};

const leaveSpeedNetworkingAction = ({ commit }, { roomId, callback }) => {
  _speedNetworkingService
    .leaveSpeedNetworking(roomId)
    .then((response) => {
      callback();
    })
    .catch((error) => console.log(error));
};

const changeCycleSpeedNetworkingAction = (
  { commit },
  { roomId, speedNetworkingMeetingId, callback }
) => {
  _speedNetworkingService
    .changeCycle(roomId, { speedNetworkingMeetingId })
    .then((response) => {
      callback();
    })
    .catch((error) => console.log(error));
};
export default {
  joinSpeedNetworkingAction,
  leaveSpeedNetworkingAction,
  setWaitingMeetingAction,
  setUserInMeetingAction,
  setEnterInNetworkingAction,
  changeCycleSpeedNetworkingAction,
  setShowEnterModalAction,
  setWaitingTimeAction,
  setMeetingTimeAction,
};
